import { render, staticRenderFns } from "./BoxUnlockTitle.vue?vue&type=template&id=445e14ec&scoped=true&"
import script from "./BoxUnlockTitle.vue?vue&type=script&lang=js&"
export * from "./BoxUnlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./BoxUnlockTitle.vue?vue&type=style&index=0&id=445e14ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e14ec",
  null
  
)

export default component.exports